import axiosInstance from "../../api/axiosConfig";

export const getCategories = () => {
  return axiosInstance.get("/home/categories");
};
